import { createSlice, current } from '@reduxjs/toolkit';
import {
	getProcedureTypeList,
	getProcedureType,
	addNewProcedureType,
	updateProcedureType,
	deleteProcedureType,
	checkProcedureTypeExists,
} from './thunk';

export const initialState = {
	itemProcedureTypeList: [],
	itemProcedureType: null,
	isProcedureTypeLoading: false,
	isProcedureTypeSuccess: false,
	dataProcedureType: null,
	statementList: [],
	statementListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	registerDisabled: false,
	requireReloadSelectionItemsGrid: false,
	exists: false,
};

const ProcedureTypeSlice = createSlice({
	name: 'ProcedureType',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getProcedureTypeList.pending, state => {
			state.isLoadingList = true;
			state.isProcedureTypeSuccess = false;
		});

		builder.addCase(getProcedureTypeList.fulfilled, (state, action) => {
			let statementList = action.payload;
			let statementListSelect = [];

			action.payload.map(item =>
				statementListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.itemProcedureTypeList = statementList;
			state.statementList = statementList;
			state.statementListSelect = statementListSelect;
			state.isLoadingList = false;
			state.isProcedureTypeSuccess = true;
		});

		builder.addCase(getProcedureTypeList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isProcedureTypeSuccess = false;
		});

		builder.addCase(getProcedureType.pending, state => {
			state.isProcedureTypeLoading = true;
			state.isProcedureTypeSuccess = false;
		});

		builder.addCase(getProcedureType.fulfilled, (state, action) => {
			state.itemProcedureType = action.payload;
			state.isProcedureTypeLoading = false;
			state.isProcedureTypeSuccess = true;
		});

		builder.addCase(getProcedureType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isProcedureTypeLoading = false;
			state.isProcedureTypeSuccess = false;
		});

		builder.addCase(addNewProcedureType.pending, state => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});

		builder.addCase(addNewProcedureType.fulfilled, (state, action) => {
			state.itemProcedureTypeList.push(action.payload);
			state.statementList.push(action.payload);
			state.statementListSelect.push({
				item: action.payload,
				value: action.payload._id,
				label: action.payload.name,
			});
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.requireCloseModal = true;
		});

		builder.addCase(addNewProcedureType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAddError = true;
		});

		builder.addCase(updateProcedureType.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});

		builder.addCase(updateProcedureType.fulfilled, (state, action) => {
			state.itemProcedureTypeList = state.itemProcedureTypeList.map(
				procedureTypeList =>
					procedureTypeList._id.toString() === action.payload._id.toString()
						? { ...procedureTypeList, ...action.payload }
						: procedureTypeList
			);
			state.statementList = state.statementList.map(procedureTypeList =>
				procedureTypeList._id.toString() === action.payload._id.toString()
					? { ...procedureTypeList, ...action.payload }
					: procedureTypeList
			);
			state.statementListSelect = state.statementListSelect.map(item =>
				item.value.toString() === action.payload._id.toString()
					? {
							item: action.payload,
							value: action.payload._id,
							label: action.payload.name,
					  }
					: item
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.requireCloseModal = true;
		});

		builder.addCase(updateProcedureType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteProcedureType.pending, state => {
			state.isLoadingList = true;
			state.isDeleting = true;
			state.isDeleted = false;
			state.isDeleteError = false;
		});

		builder.addCase(deleteProcedureType.fulfilled, (state, action) => {
			state.itemProcedureTypeList = current(
				state.itemProcedureTypeList
			).filter(item => item._id !== action.payload._id);
			state.statementList = current(state.statementList).filter(
				item => item._id !== action.payload._id
			);
			state.statementListSelect = current(state.statementListSelect).filter(
				item => item.value !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.requireCloseModal = true;
		});

		builder.addCase(deleteProcedureType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleteError = true;
		});

		builder.addCase(checkProcedureTypeExists.pending, state => {
			state.exists = false;
		});

		builder.addCase(checkProcedureTypeExists.fulfilled, (state, action) => {
			state.exists = action.payload.exists;
		});

		builder.addCase(checkProcedureTypeExists.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = ProcedureTypeSlice.actions;

export default ProcedureTypeSlice.reducer;
